import React from "react";
import NavBis from "../../components/NavBis/NavBis";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const Standings = () => {
  return (
    <div>
      <Navbar />
      <br /> <br />
      <NavBis />
      <br />
      <div
        id="wg-api-football-standings"
        data-host="v3.football.api-sports.io"
        data-key="bb124505cd72755d98cd4b1fe70500b7"
        data-league="1"
        data-team=""
        data-season="2022"
        data-theme=""
        data-show-errors="false"
        data-show-logos="true"
        className="wg_loader"
      ></div>
      <br /> <br />
      <Footer />
    </div>
  );
};

export default Standings;
